import React from 'react'
import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'react-i18next'
import './styles.scss'
import TooltipWrapper from '../../../../Shared/TooltipWrapper'
import { imageConsumptionLabelMap } from '../constants'

const ImageConsumptionBadges = ({ imageConsumptionLabels }) => {
  const { t } = useTranslation()

  const knownLabels = imageConsumptionLabels
    .filter(rawValue => imageConsumptionLabelMap[rawValue])
    .map(rawValue => imageConsumptionLabelMap[rawValue])

  if (knownLabels.length === 0) {
    return <span className="lighter-text"></span>
  }

  return (
    <div className="image-consumption-badges-group">
      {knownLabels.map(label => (
        <TooltipWrapper
          key={label.code}
          className="image-consumption-popup"
          classNameArrow="image-consumption-popup-arrow"
          place="bottom-start"
          offset={10}
          arrowSize={20}
          positionStrategy="fixed"
          content={
            <div className="image-consumption-popup__entry">
              <div className="image-consumption-popup__entry-heading">
                <span className="image-consumption-badge">{label.code}</span>
                <span className="image-consumption-popup__entry-title">{t(label.titleKey)}</span>
              </div>
              <div className="image-consumption-popup__entry-description">
                <Trans i18nKey={label.descriptionKey}/>
              </div>
            </div>
          }
        >
          <span className="image-consumption-badge">
            {label.code}
          </span>
        </TooltipWrapper>
      ))}
    </div>
  )
}

ImageConsumptionBadges.propTypes = {
  imageConsumptionLabels: PropTypes.arrayOf(PropTypes.string),
}

ImageConsumptionBadges.defaultProps = {
  imageConsumptionLabels: [],
}

export default ImageConsumptionBadges
